module.exports = __webpack_public_path__ + "static/media/info-circle.f988cd98.svg";